"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = ConfirmationBox;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _GenericStore = require("../store/GenericStore");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactI18next = require("react-i18next");

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    root: {
      '&$checked': {
        color: 'white'
      },
      borderColor: 'white'
    },
    borderColor: 'white',
    checked: {
      borderColor: 'white'
    },
    body: {
      width: '90%',
      borderRadius: '0px'
    },
    check: {
      width: '10%'
    },
    label: {
      width: '80%'
    },
    button: {
      width: '100%',
      borderRadius: '20px',
      height: 'auto',
      textTransform: 'initial'
    }
  };
});

function ConfirmationBox(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var text = props.text,
      parentPath = props.parentPath,
      block = props.block;
  var classes = useStyles();

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', false),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      checked = _useDataStore2[0],
      setChecked = _useDataStore2[1];

  var handleChange = function handleChange(event) {
    setChecked(!checked);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.body
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    startIcon: checked ? /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
      size: "large"
    }) : /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], {
      size: "large"
    }),
    className: classes.button,
    onClick: handleChange
  }, t(block.label)));
}